import { CREATE_VENDOR, CREATE_VENDOR_SUCCESS, CREATE_VENDOR_ERROR, CREATE_VENDOR_EMPTY } from './../../actionType';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const CreateVendor = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_VENDOR:
      state = {
        ...state,
        data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case CREATE_VENDOR_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: action?.payload?.message,
      };
      break;

    case CREATE_VENDOR_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case CREATE_VENDOR_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default CreateVendor;
